// Shared AWS Management Console deep-link builders.
// URLs are built entirely client-side and scoped to a region (default eu-west-1).
// No automatic account/role switching — the user signs into the correct account themselves.
// Add one function per resource type as new live pages are built.

const base = (region: string) => `https://${region}.console.aws.amazon.com`;

export const ec2InstanceUrl = (instanceId: string, region: string) =>
  `${base(region)}/ec2/home?region=${encodeURIComponent(region)}#InstanceDetails:instanceId=${encodeURIComponent(instanceId)}`;

export const lambdaFunctionUrl = (functionName: string, region: string) =>
  `${base(region)}/lambda/home?region=${encodeURIComponent(region)}#/functions/${encodeURIComponent(functionName)}`;

export const ecsServiceUrl = (cluster: string, service: string, region: string) =>
  `${base(region)}/ecs/v2/clusters/${encodeURIComponent(cluster)}/services/${encodeURIComponent(service)}?region=${encodeURIComponent(region)}`;

export const rdsInstanceUrl = (dbInstanceId: string, region: string) =>
  `${base(region)}/rds/home?region=${encodeURIComponent(region)}#database:id=${encodeURIComponent(dbInstanceId)};is-cluster=false`;

// S3 is global; the console path is s3/buckets/<name> but we still pass a region query param.
export const s3BucketUrl = (bucketName: string, region: string) =>
  `${base(region)}/s3/buckets/${encodeURIComponent(bucketName)}?region=${encodeURIComponent(region)}`;

export const loadBalancerUrl = (loadBalancerArn: string, region: string) =>
  `${base(region)}/ec2/home?region=${encodeURIComponent(region)}#LoadBalancers:loadBalancerArn=${encodeURIComponent(loadBalancerArn)}`;

export const apiGatewayUrl = (apiId: string, region: string) =>
  `${base(region)}/apigateway/main/apis/${encodeURIComponent(apiId)}/resources?region=${encodeURIComponent(region)}`;

export const dynamoDbTableUrl = (tableName: string, region: string) =>
  `${base(region)}/dynamodbv2/home?region=${encodeURIComponent(region)}#table?name=${encodeURIComponent(tableName)}`;
